// extracted by mini-css-extract-plugin
export var button = "_5n-7";
export var buttonRow = "_5n-6";
export var fadeIn = "_5n-1";
export var gradient = "_5n-0";
export var panel = "_5n-2";
export var panelIn = "_5n-3";
export var subtitle = "_5n-5";
export var title = "_5n-4";